import React from 'react';

import './Music.css';



class Music extends React.Component {
    
     
render()
{
return(
    <div className="Music">
        <h1>test</h1>
        </div>
    )};
}
export default Music;



// WEBPACK FOOTER //
// ./src/Components/Music/Music.js